'use client'

type OfflineBannerProps = {
  offlineMessage: string
  offlineDetail: string
  pendingMessage?: string
  visible: boolean
}

export function OfflineBanner({
  offlineMessage,
  offlineDetail,
  pendingMessage,
  visible,
}: OfflineBannerProps) {
  if (!visible) return null

  return (
    <div
      className="bg-status-warning-bg border-b border-status-warning/40 px-4 py-2 flex items-start gap-2"
      role="status"
    >
      <span className="material-symbols-outlined text-status-warning text-lg shrink-0 mt-0.5">
        cloud_off
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-body-sm font-semibold text-status-warning">{offlineMessage}</p>
        <p className="text-label-md text-on-surface-variant mt-0.5">{offlineDetail}</p>
        {pendingMessage && (
          <p className="text-label-md text-status-warning font-medium mt-1">{pendingMessage}</p>
        )}
      </div>
    </div>
  )
}
